module.exports = __webpack_public_path__ + "static/img/ponteH_l293D-1.f3805ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/ponteH_l293D-1.svg
// module id = IDu2
// module chunks = 0